import { create } from "zustand";

import { getIdType, getTenantMasterData, getTenantMasterPledgeData } from "@/services/Auth/AuthApi";
import { IdType, TenantMasterDataInterface } from "@/types/authService";

interface MasterState {
  idTypes: IdType[];
  idTypesLoaded: boolean;
  idTypesLoading: boolean;
  fetchIdTypes: (isActive?: boolean) => Promise<void>;
  refreshIdTypes: () => Promise<void>;
  tenantMasterDataLoading: boolean;
  fetchTenantMasterData: (referenceIds: string[]) => void;
  tenantMasterData: TenantMasterDataInterface[];
  exemptOperationsValidationMap: Record<number, string>;
  fetchExemptOperationsValidation: (branchId: number) => Promise<void>;
}

export const useMasterStore = create<MasterState>((set, get) => ({
  idTypes: [],
  idTypesLoaded: false,
  idTypesLoading: false,
  tenantMasterData: [],
  tenantMasterDataLoading: false,
  exemptOperationsValidationMap: {},

  fetchIdTypes: async (isActive = true) => {
    if (get().idTypesLoaded) return;

    set({ idTypesLoading: true });

    try {
      const { data } = await getIdType({
        is_active: isActive,
      });

      set({
        idTypes: data,
        idTypesLoaded: true,
      });
    } catch (error) {
      console.error("Failed to fetch ID Types", error);
    } finally {
      set({ idTypesLoading: false });
    }
  },
  fetchTenantMasterData: async (referenceIds: string[]) => {
    set({
      tenantMasterDataLoading: true,
    });
    try {
      const responses = await Promise.all(referenceIds.map((id) => getTenantMasterData(id)));
      set({
        tenantMasterData: responses.flatMap((response) => response.data),
      });
    } catch (error) {
      console.error("error", error);
    } finally {
      set({
        tenantMasterDataLoading: false,
      });
    }
  },
  fetchExemptOperationsValidation: async (branchId: number) => {
    try {
      const params = new URLSearchParams({
        active: "true",
        reference_ids: "S015",
        effective_branch_id: String(branchId),
      });
      const { data } = await getTenantMasterPledgeData(params.toString());
      const item = (data as any)?.find((x: any) => x.reference_id === "S015");
      let value = "2";
      if (item && item.is_active !== false) {
        value = item.value || "2";
      }

      set((state) => ({
        exemptOperationsValidationMap: {
          ...state.exemptOperationsValidationMap,
          [branchId]: value,
        },
      }));
    } catch (error) {
      console.error("Failed to fetch S015 for branch", branchId, error);
    }
  },

  refreshIdTypes: async () => {
    set({ idTypesLoading: true });

    try {
      const { data } = await getIdType({
        is_active: true,
      });

      set({
        idTypes: data,
        idTypesLoaded: true,
      });
    } catch (error) {
      console.error("Failed to refresh ID Types", error);
    } finally {
      set({ idTypesLoading: false });
    }
  },
}));
